"use client";

import { useTranslations } from "next-intl";
import { Button } from "@/components/ui/button";
import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogHeader,
	DialogTitle,
} from "@/components/ui/dialog";
import { Link } from "@/i18n/navigation";

interface DemoSignupModalProps {
	/** signup — предложение регистрации (аноним), limit — сообщение об исчерпанном лимите. */
	mode?: "signup" | "limit";
	onOpenChange: (open: boolean) => void;
	open: boolean;
}

/**
 * Окно демо-генератора (t_4c03e049, t_1c710027): регистрация для анонима
 * (форма регистрации живёт на /login) либо сообщение об исчерпанном лимите.
 */
export function DemoSignupModal({
	mode = "signup",
	open,
	onOpenChange,
}: DemoSignupModalProps) {
	const t = useTranslations("home.demoAi.signup");
	const tLimit = useTranslations("home.demoAi.limit");
	const isSignup = mode === "signup";

	return (
		<Dialog onOpenChange={onOpenChange} open={open}>
			<DialogContent className="sm:max-w-md">
				<DialogHeader>
					<DialogTitle>{isSignup ? t("title") : tLimit("title")}</DialogTitle>
					<DialogDescription>
						{isSignup ? t("body") : tLimit("body")}
					</DialogDescription>
				</DialogHeader>
				<div className="flex flex-col gap-2 pt-2">
					{isSignup && (
						<Button asChild size="lg">
							<Link href="/login?mode=signup&next=/">{t("register")}</Link>
						</Button>
					)}
				</div>
			</DialogContent>
		</Dialog>
	);
}
